import axios from "axios";
// import { useNavigate } from "react-router";

import { USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGIN_FAIL } from "../constants";

const login =
  ({ email, password }) =>
  async (dispatch) => {
    // const navigate = useNavigate();
    try {
      dispatch({ type: USER_LOGIN_REQUEST });
      const { data, status } = await axios.post("/api/v1/login", {
        email,
        password,
      });
      if (status === 200) {
        // Cookie.set(
        //   "userInfo",
        //   JSON.stringify({ ...data.data, isUserVerified: false, isLoggedIn: true })
        // );
        const loginData = await dispatch({ type: USER_LOGIN_SUCCESS, payload: data.data });
        return loginData;
        // navigate("/messages");
      }
    } catch (error) {
      const errorMsg =
        error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.msg;
      dispatch({ type: USER_LOGIN_FAIL, payload: errorMsg || "Something went error!" });
    }
  };

export default login;
